// Используем при расчете размеров элементов, чтобы корректно выставить размеры карты
export const ELEMENTS_IDS = {
  filtersId: 'search-frontend-filters',
  headerId: 'header-frontend',
  listingNodeId: 'search-frontend-listing',
  mapContainerNodeId: 'search-frontend-map-container',
  mapWrapperNodeId: 'search-frontend-map-wrapper',
} as const;
